var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPintrest(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pintrest-icon",
    transform: "translate(-1326 -4666)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_187",
    "data-name": "Rectangle 187",
    width: 41,
    height: 41,
    rx: 7,
    transform: "translate(1326 4666)",
    fill: "rgba(102,170,71,0.19)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_290_",
    transform: "translate(1334.83 4675)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3_",
    d: "M353.387,350.7a8.6,8.6,0,0,0-5.7,6.673,10.138,10.138,0,0,0,.63,5.83,5.488,5.488,0,0,0,.686,1.143.893.893,0,0,0,1.207.136,26.015,26.015,0,0,0,2.827-2.233c-2.952-3.419.024-7.657,3.932-8.6,3.643-.879,8.581.637,9.684,4.386a4.181,4.181,0,0,1-1.108,4.39,4.91,4.91,0,0,1-2.389,1.136,5.807,5.807,0,0,1-1.577.056c-.293-.031-1.434-.243-1.434-.767V356.77c0-.419-.31-.407-.659-.454-.271-.034-.542-.061-.822-.081l-3.263-.255v11.067c0,.774-.058,1.993-.784,2.4-1.044.587-2.341-.136-3.168-.822a5.356,5.356,0,0,0,1.581,3.952,4.664,4.664,0,0,0,3.769.549c2.771-.7,3.314-3.745,3.346-6.409a8.917,8.917,0,0,0,10.376-4.61,8.078,8.078,0,0,0-1.182-8.311C365.753,349.51,358.486,348.832,353.387,350.7Z",
    transform: "translate(-347.51 -349.72)",
    fill: "#66aa47"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPintrest);
export default __webpack_public_path__ + "static/media/Pintrest.bdaf368d7b382bf8193ccaa6ec184ddf.svg";
export { ForwardRef as ReactComponent };